import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { DetailedCampaign } from "../types";

async function getCampaignRequest(
  workspaceId: string,
  campaignId: string,
): Promise<DetailedCampaign> {
  return (await get(`workspaces/${workspaceId}/campaigns/${campaignId}`))
    .campaign as DetailedCampaign;
}
export default function useCampaignDetails(campaignId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const {
    data: campaign,
    isLoading: isLoadingCampaign,
    refetch: refetchCampaign,
    error: campaignError,
  } = useQuery<DetailedCampaign>({
    queryKey: campaignsKeys.details(campaignId),
    queryFn: () => getCampaignRequest(workspaceId, campaignId),
    enabled: !!campaignId,
  });

  return {
    campaign,
    campaignError,
    isLoadingCampaign,
    refetchCampaign,
  };
}
